<template>
    <div>

        <div class="form-group row align-items-center">
            <label class="col-form-label text-md-right col-md-2">Група</label>
            <div class="col-md-9">
                <multiselect
                    v-model="group"
                    label="name"
                    track-by="id"
                    :options="groups"
                    :multiple="true"
                    open-direction="bottom"
                    @input="getPrograms">
                </multiselect>
            </div>
        </div>

        <div class="form-group row align-items-center" v-if="group">
            <label class="col-form-label text-md-right col-md-2">Програма</label>
            <div class="col-md-9">
                <multiselect
                    v-model="program"
                    label="name"
                    track-by="id"
                    :options="programs"
                    :multiple="true"
                    open-direction="bottom"
                    @input="clearData"
                >
                </multiselect>
            </div>
        </div>

        <div class="form-group row align-items-center" v-if="program">
            <label class="col-form-label text-md-right col-md-2">Бал</label>
            <div class="col-md-9">
                <multiselect
                    v-model="score"
                    :options="scores"
                    :multiple="false"
                    open-direction="bottom">
                </multiselect>
            </div>
        </div>

        <div class="form-group row" v-if="program">
            <label class="col-form-label text-md-right col-md-2">День</label>
            <div class="col-md-9">
                <div class="input-group input-group--custom">
                    <div class="input-group-addon"><i class="fa fa-clock-o"></i></div>
                    <datetime
                        v-model="on_date"
                        class="flatpickr">
                    </datetime>
                </div>
            </div>
        </div>


        <div class="row" v-if="on_date && score">
            <button class="btn btn-primary btn-spinner btn-sm pull-right m-b-0" @click="getReportAveregeScoreStudents" :disabled="submiting"  type="button">
                <i class="fa" :class="submiting ? 'fa-spinner' : ''"></i>
                Завантажити звіт
            </button>	&nbsp;	&nbsp;

            <button class="btn btn-primary btn-spinner btn-sm pull-right m-b-0" @click="saveReportAveregeScoreStudents" :disabled="submiting" type="button">
                <i class="fa" :class="submiting ? 'fa-spinner' : ''"></i>
                Зберегти звіт
            </button>
            <br>
            <br>
        </div>

        <div class="row">
            <div class="col-12 table-reports"  v-for="teacher in data_teachers">
                <table class="table is_middle table-condensed table-bordered" v-for="group in teacher.groups">
                    <template>
                        <tr>
                            <td colspan="1000" style="background: #ccc">{{teacher.full_name}}</td>
                        </tr>
                        <tr>
                            <td colspan="1000" style="background: #ccc">{{group.name}}</td>
                        </tr>
                        <template >
                            <tr>
                                <td>students</td>
                                <td :colspan="(program.format === 0) ? 4 : 3" style="background: #eee" v-for="program in group.programs">{{program.name}}</td>
                            </tr>
                            <tr v-for="(student, index) in group.students">
                                <td>
                                    {{ student.full_name }}
                                </td>
                                <template v-for="student_program in student.data_programs">
                                    <td>Online: {{ student_program.avg_score_online }}</td>
                                    <td v-if="student_program.format === 0">Offline:{{ student_program.avg_score_offline }}</td>
                                    <td>Averege Score :{{ student_program.avg_score }}</td>
                                    <td>{{ student_program.score_symbol }}</td>
                                </template>
                            </tr>
                        </template>
                    </template>
                </table>
            </div>
        </div>
    </div>

</template>
<style scoped>
    .table-reports {
        overflow-x: auto;
        max-width: 100%;
    }
    .table-reports:empty {
        display: none;
    }
    .table-reports tr td {
        padding: 8px;
    }
</style>
<script>
    import axios from "axios";

    export default {
        name: "TeacherReportsAverageScoreComponent",
        props: [ 'groups'],
        data() {
            return {

                score: null,
                scores: ['A+','A','A-','B+','B','B-','C+','C','C-','D+','D','D-','F'],

                submiting: false,

                group: null,

                program: null,
                programs: [],

                on_date: new Date().toISOString().slice(0, 10),
                data_teachers: null,
            }
        },
        computed: {},
        mounted() {

        },
        methods: {


            clearData(){
                this.on_date = null;
            },

            async getPrograms(){
                const { data: { programs } } = await axios.post('/teacher/dashboard/reports/getPrograms', {
                    'groups': this.group,
                });
                this.programs = programs;
            },


            async getReportAveregeScoreStudents(){
               this.submiting = true;

               try {
                   const { data: { teachers } } = await axios.post('/teacher/dashboard/reports/getReportAveregeScoreStudents', {
                       'groups': this.group,
                       'programs': this.program,
                       'score': this.score,
                       'on_date': this.on_date,
                   });

                   this.data_teachers = teachers;
                   this.submiting = false;
               }catch (e) {
                   console.log(e);
                   this.submiting = false;
               }

            },

            async saveReportAveregeScoreStudents(){
                this.submiting = true;

                try {
                    const { data: { file_name } } = await axios.post('/teacher/dashboard/reports/getReportAveregeScoreStudents', {
                        'groups': this.group,
                        'programs': this.program,
                        'score': this.score,
                        'on_date': this.on_date,
                        'save': true,
                    });
                    location.href = file_name;

                    this.submiting = false;
                } catch (e) {
                    console.log(e);
                    this.submiting = false;
                }

            }
        }
    }
</script>
